import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer bg-gradient-to-r from-primary-700 via-primary to-primary-600 text-white mt-20">
      <div className="container py-12">
        <div className="row">
          <div className="col-md-4 mb-8">
            <h5 className="mb-4 font-bold">
              <i className="fas fa-mosque me-2"></i>Islamic School
            </h5>
            <p className="text-white/90">
              Providing quality Islamic education with modern curriculum.
              Building strong Muslim leaders for tomorrow.
            </p>
            <div className="islamic-quote mt-6 p-4 bg-white/10 rounded-xl">
              <p className="mb-2 font-arabic text-lg">
                <i className="fas fa-quote-left me-2"></i>
                "Read in the name of your Lord who created"
                <i className="fas fa-quote-right ms-2"></i>
              </p>
              <small className="text-white/80">- Quran 96:1</small>
            </div>
          </div>

          <div className="col-md-4 mb-8">
            <h5 className="mb-4 font-bold">Quick Links</h5>
            <ul className="list-unstyled space-y-2">
              <li><Link to="/" className="text-white/90 hover:text-white transition-all"><i className="fas fa-angle-right me-2"></i>Home</Link></li>
              <li><Link to="/about" className="text-white/90 hover:text-white transition-all"><i className="fas fa-angle-right me-2"></i>About Us</Link></li>
              <li><Link to="/academics" className="text-white/90 hover:text-white transition-all"><i className="fas fa-angle-right me-2"></i>Academics</Link></li>
              <li><Link to="/admission" className="text-white/90 hover:text-white transition-all"><i className="fas fa-angle-right me-2"></i>Admission</Link></li>
              <li><Link to="/contact" className="text-white/90 hover:text-white transition-all"><i className="fas fa-angle-right me-2"></i>Contact Us</Link></li>
            </ul>
          </div>

          <div className="col-md-4 mb-8">
            <h5 className="mb-4 font-bold">Contact Information</h5>
            <ul className="list-unstyled space-y-2">
              <li className="text-white/90">
                <i className="fas fa-map-marker-alt me-2"></i>
                123 Islamic Street, Lagos, Nigeria
              </li>
              <li className="text-white/90">
                <i className="fas fa-phone me-2"></i>
                +234 123 456 7890
              </li>
              <li className="text-white/90">
                <i className="fas fa-envelope me-2"></i>
                info@islamicschool.com
              </li>
              <li className="text-white/90">
                <i className="fas fa-clock me-2"></i>
                Mon - Fri: 8:00 AM - 4:00 PM
              </li>
            </ul>
            <div className="social-links mt-6">
              <a href="#" className="text-white me-4 hover:scale-110 transition-all"><i className="fab fa-facebook-f text-xl"></i></a>
              <a href="#" className="text-white me-4 hover:scale-110 transition-all"><i className="fab fa-twitter text-xl"></i></a>
              <a href="#" className="text-white me-4 hover:scale-110 transition-all"><i className="fab fa-instagram text-xl"></i></a>
              <a href="#" className="text-white hover:scale-110 transition-all"><i className="fab fa-youtube text-xl"></i></a>
            </div>
          </div>
        </div>

        <hr className="my-8 bg-white/20" />

        <div className="text-center">
          <p className="mb-0 text-white/80">
            &copy; {year} Islamic School. All Rights Reserved.
            <span className="ms-4">
              <i className="fas fa-heart text-red-400"></i> Made with dedication
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

